import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { TwoColAreaComponent } from './two-col-area/two-col-area.component';
import { ImgBigComponent } from './img-big/img-big.component';
import { OneColAreaComponent } from './one-col-area/one-col-area.component';
import { OneColAreaButtonComponent } from './one-col-area-button/one-col-area-button.component';
import { BtnMoreComponent } from './btn-more/btn-more.component';
import { ThreeColAreaButtonComponent } from './three-col-area-button/three-col-area-button.component';
import { TwoColAreaPhotoButtonComponent } from './two-col-area-photo-button/two-col-area-photo-button.component';
import { OneColAreaButtonH1Component } from './one-col-area-button-h1/one-col-area-button-h1.component';
import { FooterMainComponent } from './footer-main/footer-main.component';
import { Error404Component } from './error404/error404.component';
import { RouterModule } from '@angular/router';
import { TitleSectionComponent } from './title-section/title-section.component';
import { OneColCarouselComponent } from './one-col-carousel/one-col-carousel.component';
import { OneColCarouselTextComponent } from './one-col-carousel-text/one-col-carousel-text.component';
import { TwoColAreaNoButtonComponent } from './two-col-area-no-button/two-col-area-no-button.component';
import { CookiesModalComponent } from './cookies-modal/cookies-modal.component';

import { ReversePipe } from './pipes/reverse.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { OneColAreaNobuttonComponent } from './one-col-area-nobutton/one-col-area-nobutton.component';
import { VideoAutoComponent } from './video-auto/video-auto.component';

@NgModule({
  declarations: [
    HeaderComponent,
    TwoColAreaComponent,
    ImgBigComponent,
    OneColAreaComponent,
    OneColAreaButtonComponent,
    BtnMoreComponent,
    ThreeColAreaButtonComponent,
    TwoColAreaPhotoButtonComponent,
    OneColAreaButtonH1Component,
    FooterMainComponent,
    Error404Component,
    TitleSectionComponent,
    OneColCarouselComponent,
    OneColCarouselTextComponent,
    TwoColAreaNoButtonComponent,
    CookiesModalComponent,
    ReversePipe,
    OrderByPipe,
    OneColAreaNobuttonComponent,
    VideoAutoComponent,
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    HeaderComponent,
    TwoColAreaComponent,
    ImgBigComponent,
    OneColAreaComponent,
    OneColAreaButtonComponent,
    BtnMoreComponent,
    ThreeColAreaButtonComponent,
    TwoColAreaPhotoButtonComponent,
    OneColAreaButtonH1Component,
    TitleSectionComponent,
    FooterMainComponent,
    Error404Component,
    OneColCarouselComponent,
    OneColCarouselTextComponent,
    TwoColAreaNoButtonComponent,
    CookiesModalComponent,
    ReversePipe,
    OrderByPipe,
    OneColAreaNobuttonComponent,
    VideoAutoComponent
  ],
  providers: [
    { provide: Window, useValue: window },
    { provide: Document, useValue: document }
  ]
})
export class SharedModule { }
